import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { PhxBreakpointObserverService } from '../../services/phx-breakpoint-service';
import { KeyboardKeys } from '../../helpers/KeyboardKeys.enum';

type PhxModalUpsellVariant = 'offer' | 'requested';

@Component({
  selector: 'phx-modal-upsell',
  templateUrl: './phx-modal-upsell.component.html',
  styleUrls: ['./phx-modal-upsell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxModalUpsellComponent implements OnInit, OnDestroy {
  @Input() public phxVariant: PhxModalUpsellVariant = 'offer';
  @Input() public phxOpen: boolean = false;

  @Output() public phxOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public phxBackdropClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() public phxEscKeyPressed: EventEmitter<void> = new EventEmitter<void>();

  public isMobileView: boolean = false;

  private _breakpointSub!: Subscription;

  constructor(
    private _breakpointObserver: PhxBreakpointObserverService,
    private _cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._breakpointSub = this._breakpointObserver.smMobile.subscribe((isMobile) => {
      this.isMobileView = isMobile;
      this._cdr.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    this._breakpointSub.unsubscribe();
  }

  public onBackdropClicked(): void {
    this.phxBackdropClicked.emit();
    this.closeModal();
  }

  public closeModal(): void {
    this.phxOpen = false;
    this.phxOpenChange.emit(false);
  }

  public onKeydown(event: KeyboardEvent): void {
    if (this.phxOpen && event.key === KeyboardKeys.ESC) {
      this.phxEscKeyPressed.emit();
      event.preventDefault();
      this.closeModal();
    }
  }
}
